import { useQuery } from '@tanstack/react-query';

import { endpoints } from './api';

/**
 * The top bar's search, across products, orders and customers at once. The API
 * answers each kind only to the permission its own list asks, so the box that
 * uses this is offered only to a session that may open one of those lists.
 */
export function useGlobalSearch(query: string) {
    return useQuery({
        queryKey: ['search', query],
        queryFn: () => endpoints.search(query),
        // Two characters, because a single letter matches most of a catalogue and
        // the result is a list nobody reads.
        enabled: query.trim().length >= 2,
    });
}
